import { QuanLyVanBan } from 'api';
import DataTable from 'components/data-table';
import { msg } from 'constants/message';
import { header } from 'constants/table';
import { MasterLayout } from 'layout';
import { Toastr } from 'modules/toastr';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import SearchDanhMucVanBan from './SearchDanhMucVanBan.jsx';
import { RowItemDanhMucVanBan } from './datatable';
import { API_URL } from 'constants/config';
import { exportExcel } from "constants/exportExcel";

class DanhMucVanBan extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tenVanBan: '',
      search: false
    };
  }

  componentDidMount() {
    this.getListData();
  }

  handleSearch() {
    this.setState({
      search: true
    });
    this.getListData(true);
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: isSearch ? 0 : this.state.pageData.number,
      size: this.state.pageData.size,
    }
    if (this.state.tenVanBan) {
      params.tenVanBan = this.state.tenVanBan.trim();
    }
    QuanLyVanBan.actions.getDanhMucVanBan.request(null, params).then(res => {
      if (res.data) {
        this.setState({
          data: res.data.contents,
          pageData: {
            number: res.data.pageNumber,
            size: res.data.pageSize,
            totalElements: res.data.totalElements,
            totalPages: res.data.totalPages
          },
          tableLoading: false,
          searchLoading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false,
          searchLoading: false
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleDelete(idLoaiVanBan) {
    if (idLoaiVanBan) {
      this.setState({ buttonLoading: true });
      QuanLyVanBan.actions.deleteDanhMucVanBan.request({ id: idLoaiVanBan }).then(res => {
        this.getListData();
        Toastr(msg.delCategorySucess, 'success');
        this.setState({ buttonLoading: false });
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].description, 'error');
          this.setState({ buttonLoading: false });
        }
      });
    }
  }
  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleExport() {
    const URL = String(API_URL) + "/danh-muc-van-ban"
    exportExcel(URL, 'danhmucvanban.xlsx');
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Quản lý danh mục văn bản</p>
            </div>
            <div className="right-content">
              <Link className="btn-green" to='/quan-ly-van-ban/danh-sach-van-ban/them-moi'><i className="tt tt-addfile"></i>Thêm mới</Link>
            </div>
          </div>
          <div className="bottom-content">
            <SearchDanhMucVanBan parents={this} />
            <DataTable
              header={header.quanLyVanBan.dsQuanLyDanhMucVanBan}
              dataList={this.state.data}
              pageData={this.state.pageData}
              handleExport={this.handleExport.bind(this)}
              exporttext="Xuất Excel"
              thanhTra
              hideButtonExport={true}
              parent={this}
              search={this.state.search}
              tableLoading={this.state.tableLoading}
            >
              <RowItemDanhMucVanBan />
            </DataTable>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

DanhMucVanBan.defaultProps = {
}

export default connect()(DanhMucVanBan);



// WEBPACK FOOTER //
// ./src/components/modules/quan-ly-van-ban/DanhMucVanBan.jsx